"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSwitchElement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var ACSwitchElement = function (props) {
    var onChange = function (checked) {
        props.onChange && props.onChange(checked);
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Switch, { value: props.value, checkedChildren: props.checkedChildren, unCheckedChildren: props.unCheckedChildren, onChange: onChange }));
};
exports.ACSwitchElement = ACSwitchElement;
